import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import networks_gen_2_plus from '@devices/settings/device_settings/networks_gen_2_plus.js';
import safety_gen_2 from '@devices/settings/device_settings/safety_gen_2.js';
import plugs_app_settings from '@devices/settings/device_settings/plugs_app_settings.js';
import share from '@devices/settings/device_settings/share.js';
import settings_gen_2_plugs from '@devices/settings/device_settings/settings_gen_2_plugs.js';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyAZPlug',
	friendly_name: 'AZ Plug',
	family: 'relay',
	isPM: true,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 1,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			meters: 1,
			rollers: 0,
			control_holder: 0,
			default_icon: 'socket.png',
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				networks_gen_2_plus,
				bluetooth_gen_2,
				safety_gen_2,
				plugs_app_settings,
				share,
				settings_gen_2_plugs,
			],
		},
	},
};
